export default "__VITE_ASSET__Bcglq_RJ__"